exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms[data-v-c29f9bf0]{text-align:right;padding:0 2em}", ""]);

// exports
